<template>
  <div>
    <b-row align-h="center" style="margin-bottom: 40px; text-align: center" v-if="activeContent === 'select-duration'">
      <b-col cols="12" md="4">
        <div class="duration-container">
          <h4 class="font-weight-bold mb-4">Select Duration</h4>
          <div class="d-flex flex-column align-items-start">
            <div class="d-flex flex-column duration-item">
              <div class="small-muted-text text-left">Recurring</div>
              <div class="d-flex align-items-start">
                <div class="input-radio d-flex align-items-start">
                  <input type="radio" :value="true" name="recurring" v-model="recurring">
                </div>
                <div class="d-flex flex-column">
                  <span class="duration-text">Monthly Subscription</span>
                  <div class="duration-images d-flex align-items-start">
                    <img src="@/assets/visa.png" alt="logo" />
                    <img src="@/assets/master.png" alt="logo" />
                    <img src="@/assets/american-express.png" alt="logo" />
                    <img src="@/assets/apple-pay.png" alt="logo" v-if="canApplePay"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="line-separator"></div>
            <div class="d-flex flex-column duration-item">
              <div class="small-muted-text text-left">ONE-TIME PAYMENT</div>
              <div class="d-flex align-items-start">
                <div class="input-radio d-flex align-items-start">
                  <input type="radio" :value="false" name="recurring" v-model="recurring">
                </div>
                <div class="d-flex flex-column">
                  <b-form-select
                    v-model="oneTimeMonth"
                    :options="listMonth"
                    style="margin-bottom: 9px"
                  ></b-form-select>
                  <div class="duration-images d-flex align-items-start">
                    <img src="@/assets/visa.png" alt="logo" />
                    <img src="@/assets/master.png" alt="logo" />
                    <img src="@/assets/american-express.png" alt="logo" />
                    <img src="@/assets/grabpay.png" alt="logo" v-if="getUser.data.country.code === 'PH'"/>
                    <img src="@/assets/gcash.png" alt="logo" v-if="getUser.data.country.code === 'PH'"/>
                    <img src="@/assets/wechat.png" alt="logo" />
                    <img src="@/assets/apple-pay.png" alt="logo" v-if="canApplePay"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-primary btn-block mb-3 mt-5" @click="submitDuration">Select Amount</button>
          <div class="text-center d-flex flex-column align-items-start">
            <span  style="margin-top:5px;margin-bottom: -3px;">*All prices exclusive of service fee</span>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row align-h="center" style="margin-bottom: 40px; text-align: center" v-if="activeContent === 'select-amount'">
      <b-col cols="12" md="5">
        <h4 class="font-weight-bold mb-4">Select Amount</h4>
        <span class="fire mb-2">🔥 Limited time. Pay what you can afford</span>
        <h5 class="mb-4">{{membershipText}}</h5>
        <div class="range-container">
          <div class="d-flex flex-column align-items-center mb-3">
            <span class="price-approx">{{approxText}}</span>
            <span class="price-text mb-1" v-bind:class="inputType==='slider'? textRule : ''">${{ inputType==='slider'?rangeVal:inputPrice}}</span>
            <span class="price-per-month" v-if="recurring === true">/month</span>
          </div>
          <div class="d-inline-block w-100 mb-5 px-3" v-if="inputType === 'slider'">
            <vue-slider
              v-model="rangeVal"
              :tooltip="'none'"
              :min="min"
              :max="max"
              :dot-size="32"
              :dot-style="{background:'#224181'}"
              :rail-style="{backgroundColor:'#AAAAAA'}"
              :contained="true"
              :marks="marks"
              @change="selectPrice"
              v-if="activeContent === 'select-amount'"
            >
              <template v-slot:mark="{ pos, label }" v-if="recurring === true">
                <div class="custom-mark-start" v-if="label === lowestPrice">
                  ${{ label }}
                </div>
                <div v-else-if="label === defaultPrice" class="custom-mark" :style="{ left: `${pos}%` }">
                  <font-awesome-icon :icon="['fas', 'caret-up']" size="3x" class="arrow" ></font-awesome-icon>
                  <div class="recommend-text">Recommended Price</div>
                </div>
                <div v-else-if="label === max" class="custom-mark-end">
                  ${{ label }}
                </div>
              </template>
              <template v-slot:mark="{ pos, label }" v-else-if="!recurring">
                <div class="custom-mark-start" v-if="label === lowestPrice">
                  ${{ label }}
                </div>
                <div class="custom-mark" :style="{ left: `${pos}%` }" v-if="label === defaultPrice">
                  <font-awesome-icon :icon="['fas', 'caret-up']" size="3x" class="arrow" ></font-awesome-icon>
                  <div class="recommend-text">Recommended Price</div>
                </div>
                <div v-else-if="label === max" class="custom-mark-end">
                  ${{ label }}
                </div>
              </template>
            </vue-slider>
          </div>
          <div class="info-text d-inline-block w-90 mt-2" v-bind:class="infoTextColor" v-if="inputType === 'slider'">
            {{infoTextRule}}
          </div>
          <div class="d-inline-block w-100 mt-5 position-relative" style="height: 56px" v-if="inputType === 'input'">
            <input @keyup="inputChange" type="number" min="100" class="form-control input-custom-form" v-model="inputPrice"/>
            <img src="@/assets/dollar.svg" class="position-absolute ml-2" style="top: 10px;left: 10px;"/>
          </div>
          <div class="d-flex w-100 justify-content-center mt-3" v-if="inputType === 'input' && !isValidInputCustom">
            <span class="text-danger">Minimum amount is 100</span>
          </div>
          <div class="d-flex justify-content-center mt-5">
            <a class="input-custom cursor-pointer" @click="inputCustom">
              {{ inputType==='slider'?'Input more than $100 ':'Back to Default'}}
            </a>
          </div>
          <template v-if="recurring">
            <button class="btn btn-primary btn-block mb-3 mt-5" @click="pay" :disabled="inputType === 'input' && !isValidInputCustom">Go to payment</button>
            <div class="text-center d-flex flex-column align-items-center">
              <span  style="margin-top:5px;margin-bottom: -3px;">*All prices exclusive of Stripe fees</span>
              <span >*1% additional fee will be added for countries outside US</span>
            </div>
          </template>
          <template v-else-if="!recurring">
            <button class="btn btn-primary btn-block mb-3 mt-5" @click="goToPaymentMethod" :disabled="inputType === 'input' && !isValidInputCustom">Go to payment method</button>
            <div class="text-center d-flex flex-column align-items-center">
              <span  style="margin-top:5px;margin-bottom: -3px;">*All prices are exclusive of service fee</span>
            </div>
          </template>

        </div>
      </b-col>
      <div class="w-100"></div>
      <b-col cols="12" md="4" class="d-flex justify-content-center">
        <a class="btn-back d-flex rounded-circle cursor-pointer" @click="back">
          <font-awesome-icon :icon="['fas', 'chevron-left']" class="icon-back" />
        </a>
      </b-col>
    </b-row>
    <b-row align-h="center"  style="margin-bottom: 40px; text-align: center" v-if="activeContent === 'select-payment'">
      <b-col cols="12" md="4">
        <div class="payment-container">
          <h4 class="font-weight-bold mb-4">Select Payment</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-column">
              <span class="small-muted-text text-left">CARD</span>
              <div class="d-flex flex-column" style="margin-bottom: 68px">
                <div class="d-flex">
                  <div class="input-radio-payment">
                    <input type="radio" name="payment_method" value="credit_card" v-model="paymentMethod"
                           @click="changePaymentMethod" />
                  </div>
                  <div class="payment-method-label w-100 text-left">
                    Credit Card / Debit Card
                  </div>
                  <div class="payment-method-images d-flex justify-content-end">
                    <img src="@/assets/visa.png" alt="logo" />
                    <img src="@/assets/master.png" alt="logo" />
                    <img src="@/assets/american-express.png" alt="logo" />
                    <img src="@/assets/apple-pay.png" alt="logo" v-if="canApplePay"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column" v-if="!recurring">
              <span class="small-muted-text text-left">WALLET</span>
              <div class="d-flex flex-column" style="margin-bottom: 40px">
                <div class="d-flex payment-item justify-content-between" v-if="getUser.data.country.code === 'PH'">
                  <div class="input-radio-payment">
                    <input type="radio" name="payment_method" value="grab_pay" v-model="paymentMethod"
                           @click="changePaymentMethod"/>
                  </div>
                  <div class="payment-method-label text-left w-100">
                    GrabPay
                  </div>
                  <div class="payment-method-images d-flex justify-content-end">
                    <img src="@/assets/grabpay.png" alt="logo" />
                  </div>
                </div>
                <div class="d-flex payment-item justify-content-between" v-if="getUser.data.country.code === 'PH'">
                  <div class="input-radio-payment">
                    <input type="radio" name="payment_method" value="gcash" v-model="paymentMethod"
                           @click="changePaymentMethod" />
                  </div>
                  <div class="payment-method-label text-left w-100">
                    GCash
                  </div>
                  <div class="payment-method-images d-flex justify-content-end">
                    <img src="@/assets/gcash.png" alt="logo" />
                  </div>
                </div>
                <div class="d-flex payment-item justify-content-between">
                  <div class="input-radio-payment">
                    <input type="radio" name="payment_method" value="wechat" v-model="paymentMethod"
                           @click="changePaymentMethod" />
                  </div>
                  <div class="payment-method-label text-left w-100">
                    WeChat Pay
                  </div>
                  <div class="payment-method-images d-flex justify-content-end">
                    <img src="@/assets/wechat.png" alt="logo" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-primary btn-block mb-3 mt-5" @click="pay">Go to payment</button>
          <div class="text-center d-flex flex-column align-items-start">
            <span  style="margin-top:5px;margin-bottom: -3px;">*All prices exclusive of service fee</span>
          </div>
        </div>
      </b-col>
      <div class="w-100"></div>
      <b-col cols="12" md="4" class="d-flex justify-content-center mt-5">
        <a class="btn-back d-flex rounded-circle cursor-pointer" @click="backPayment">
          <font-awesome-icon :icon="['fas', 'chevron-left']" class="icon-back" />
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import { mapActions, mapGetters } from 'vuex';
import authHeader from '@/helper/authHeader';
import axios from 'axios';
import helperMixins from '../mixins/helpers.mixins';

const BASE_URL = process.env.BASE_URL;
const APPLE_MERCHANT_ID = process.env.APPLE_MERCHANT_ID;
const API_URL = process.env.API_URL;
// const additionalCountryPrice = ['US', 'GB', 'CA', 'CO'];
export default {
  name: 'SubscribePage',
  mixins: [helperMixins],
  data() {
    return {
      list: [],
      selectedPlan: null,
      subscribeData: {
        country: '',
        currency: '',
        identifier: '',
        price: 0,
        lowest_price: 0,
        recurring: true,
        defaultPrice: 0,
        paymentMethod: 'credit_card',
        checkout_url: '',
      },
      rangeVal: 1,
      min: 1,
      max: 100,
      marks: false,
      activeContent: 'select-duration',
      recurring: true,
      oneTimeMonth: 1,
      listMonth: [
        {
          value: 2,
          text: '2 Months',
        },
        {
          value: 3,
          text: '3 Months',
        },
        {
          value: 6,
          text: '6 Months',
        },
        {
          value: 9,
          text: '9 Months',
        },
        {
          value: 12,
          text: '12 Months',
        },
      ],
      paymentMethod: null,
      defaultPrice: 1,
      lowestPrice: 1,
      inputType: 'slider',
      inputPrice: 100,
      canApplePay: false,
      showSetupApple: false,
    };
  },
  async mounted() {
    this.list = [];
    if (this.subscriptionTrxData !== '') {
      if (this.paymentPending === '') {
        Vue.swal({
          title: 'Warning',
          text: 'The other transaction is on the way. Please finish it before create new transaction',
          icon: 'warning',
          confirmButtonText: 'Continue Payment',
          cancelButtonText: 'Cancel Transaction',
          showConfirmButton: true,
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-danger',
          },
        }).then(async (result) => {
          if (result.value) {
            if (this.subscriptionTrxData.recurring ||
              (!this.subscriptionTrxData.recurring && (this.subscriptionTrxData.paymentMethod === 'credit_card' || this.subscriptionTrxData.paymentMethod === 'wechat'))) {
              await this.$stripe.redirectToCheckout({
                sessionId: this.subscriptionTrxData.session_id,
              });
            } else {
              document.location.href = this.subscriptionTrxData.checkout_url;
            }
          } else {
            this.removePaymentDataSubscription();
            this.$router.push({ name: 'HomePage' });
          }
        });
      } else {
        await this.verifyPaymentPending();
      }
    } else {
      await this.requestDetailUser();
      // if (this.getUser.data.type === 0) {
      await this.requestListSubscription();
      if (this.getUser.data.country.code !== 'PH') {
        this.listMonth.unshift({
          value: 1,
          text: '1 Month',
        });
      } else {
        this.oneTimeMonth = 2;
      }
      if (this.getStatus === 401) {
        Vue.swal({
          title: 'Happy Sabbath!',
          text: this.getMessage,
          confirmButtonText: 'Yes',
          cancelButtonText: 'Back to Home',
          showConfirmButton: false,
          showCancelButton: true,
        }).then(async (result) => {
          this.$router.push({ name: 'HomePage' });
        });
      } else if (this.getStatus !== 200) {
        Vue.swal({
          title: this.getStatus,
          text: this.getMessage,
          icon: 'warning',
          confirmButtonText: 'Yes',
          cancelButtonText: 'Back to Home',
          showConfirmButton: false,
          showCancelButton: true,
        }).then(async (result) => {
          this.$router.push({ name: 'HomePage' });
        });
      }
      this.initApple();
      // } else {
      //   this.$router.push({ name: 'HomePage' });
      // }
    }
  },
  computed: {
    ...mapGetters('CreditsAmountModule', ['listSubscriptionPrice']),
    ...mapGetters('PaymentModule', ['subscriptionTrxData', 'paymentPending']),
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['getUser', 'getFromApps']),
    approxText() {
      let price = 0;
      if (this.inputType === 'slider') {
        if (this.marks) {
          price = (this.rangeVal * this.subscribeData.rate).toFixed(2);
        }
      } else {
        price = (this.inputPrice * this.subscribeData.rate).toFixed(2);
      }
      return `Approx ${this.subscribeData.user_currency} ${this.formatPrice(price)}`;
    },
    textRule() {
      let rule = '';
      if (this.subscribeData.price === this.subscribeData.lowest_price) {
        rule = 'rule-1-price';
      } else if (this.subscribeData.price > this.subscribeData.lowest_price && this.subscribeData.price <= this.subscribeData.defaultPrice) {
        rule = 'rule-2-price';
      } else if (this.subscribeData.price > this.subscribeData.defaultPrice && this.subscribeData.price < 20) {
        rule = 'rule-3-price';
      } else if (this.subscribeData.price >= 20 && this.subscribeData.price < 50) {
        rule = 'rule-4-price';
      } else if (this.subscribeData.price >= 50 && this.subscribeData.price < 100) {
        rule = 'rule-5-price';
      } else if (this.subscribeData.price >= 100) {
        rule = 'rule-6-price';
      }
      return rule;
    },
    infoTextRule() {
      let rule = '';
      if (this.subscribeData.price === this.subscribeData.lowest_price) {
        rule = 'If you can’t afford the suggested price. You can lower the number to pay what you can afford';
      } else if (this.subscribeData.price > this.subscribeData.lowest_price && this.subscribeData.price <= this.subscribeData.defaultPrice) {
        rule = 'If you can’t afford the suggested price. You can lower the number to pay what you can afford';
      } else if (this.subscribeData.price > this.subscribeData.defaultPrice && this.subscribeData.price < 20) {
        rule = '';
      } else if (this.subscribeData.price >= 20 && this.subscribeData.price < 50) {
        rule = 'Thank you for being a cheerful giver. You\'re on the top 1% subscribers who input $20 or more.';
      } else if (this.subscribeData.price >= 50 && this.subscribeData.price < 100) {
        rule = 'We are grateful for your generosity. You\'re on the top 0.5% subscribers who input $50 or more.';
      } else if (this.subscribeData.price >= 100) {
        rule = 'You\'re awesome! We thank you for your abundant support on MusicVerse & missions.';
      }
      return rule;
    },
    infoTextColor() {
      let rule = '';
      if (this.subscribeData.price >= 20 && this.subscribeData.price < 50) {
        rule = 'rule-4-info';
      } else if (this.subscribeData.price >= 50 && this.subscribeData.price < 100) {
        rule = 'rule-5-info';
      } else if (this.subscribeData.price >= 100) {
        rule = 'rule-6-info';
      }
      return rule;
    },
    membershipText() {
      return this.recurring ? 'Monthly Membership' : `${this.oneTimeMonth}-Month Membership`;
    },
    isValidInputCustom() {
      return this.inputPrice >= 100;
    },
  },
  watch: {
    listSubscriptionPrice: {
      immediate: true,
      deep: true,
      async handler(val) {
        if (this.listSubscriptionPrice != undefined && this.listSubscriptionPrice != null) {
          const subs = this.listSubscriptionPrice;
          this.subscribeData = {
            ...subs,
            country: subs.country,
            currency: subs.currency,
            identifier: subs.identifier.replaceAll('-', '_'),
            price: subs.price,
            defaultPrice: subs.price,
            recurring: true,
          };
          this.defaultPrice = subs.price;
          this.lowestPrice = subs.lowest_price;
          this.min = subs.lowest_price;
          this.rangeVal = subs.price;
          this.marks = true;
        }
      },
    },
  },
  methods: {
    ...mapActions('CreditsAmountModule', ['requestListSubscription']),
    ...mapActions('PaymentModule', ['setPaymentDataSubscription', 'removePaymentDataSubscription',
      'requestMakePaymentSubscription', 'requestMakePaymentSubscriptionWeChat',
      'requestMakePaymentSubscriptionPayMongo', 'requestConfirmPaymentSubscriptionPayMongo']),
    ...mapActions('NotificationModule', ['setLoading', 'unsetLoading']),
    ...mapActions('AuthModule', ['requestDetailUser']),
    inputCustom() {
      if (this.inputType === 'slider') {
        this.inputType = 'input';
      } else {
        this.inputType = 'slider';
      }
    },
    inputChange() {
      if (this.inputPrice < 100) {
        // this.inputPrice = 100;
      }
    },
    selectPrice(val) {
      this.subscribeData = { ...this.subscribeData, price: val };
    },
    changePaymentMethod(val) {
      this.subscribeData = { ...this.subscribeData, paymentMethod: val };
    },
    submitDuration() {
      if (this.recurring === null) {
        Vue.swal({
          title: 'Error',
          text: 'Please Select Duration',
          icon: 'error',
          cancelButtonText: 'Close',
          showConfirmButton: false,
          showCancelButton: true,
        });
      } else {
        const subs = this.listSubscriptionPrice;
        if (this.recurring) {
          this.defaultPrice = subs.price;
          this.lowestPrice = subs.lowest_price;
          this.min = subs.lowest_price;
          this.rangeVal = subs.price;
          this.max = 100;
        } else {
          switch (this.oneTimeMonth) {
            case 1:
              this.defaultPrice = subs.price;
              this.lowestPrice = 1;
              this.min = 1;
              this.rangeVal = subs.price;
              this.max = 100;
              break;
            case 2:
              this.defaultPrice = 2 * subs.price;
              this.lowestPrice = 2;
              this.min = 2;
              this.rangeVal = 2 * subs.price;
              this.max = 100;
              break;
            case 3:
              this.defaultPrice = 3 * subs.price;
              this.lowestPrice = 3;
              this.min = 3;
              this.rangeVal = 3 * subs.price;
              this.max = 120;
              break;
            case 6:
              this.defaultPrice = 6 * subs.price;
              this.lowestPrice = 6;
              this.min = 6;
              this.rangeVal = 6 * subs.price;
              this.max = 120;
              break;
            case 9:
              this.defaultPrice = 9 * subs.price;
              this.lowestPrice = 9;
              this.min = 9;
              this.rangeVal = 9 * subs.price;
              this.max = 120;
              break;
            case 12:
              this.defaultPrice = 12 * subs.price;
              this.lowestPrice = 12;
              this.min = 12;
              this.rangeVal = 12 * subs.price;
              this.max = 120;
              break;
          }
        }
        this.subscribeData = { ...this.subscribeData, price: this.rangeVal, recurring: this.recurring };
        this.activeContent = 'select-amount';
      }
    },
    goToPaymentMethod() {
      this.activeContent = 'select-payment';
    },
    async pay() {
      this.subscribeData = { ...this.subscribeData, recurring: this.recurring };
      if (this.inputType === 'input') {
        this.subscribeData = { ...this.subscribeData, price: this.inputPrice };
      }
      if (this.recurring) {
        this.subscribeData = { ...this.subscribeData, paymentMethod: 'credit_card' };
        await this.payStripe();
      } else if (this.paymentMethod === null) {
        Vue.swal({
          title: 'Error',
          text: 'Please Select Payment Method',
          icon: 'error',
          cancelButtonText: 'Close',
          showConfirmButton: false,
          showCancelButton: true,
        });
      } else {
        this.subscribeData = { ...this.subscribeData, paymentMethod: this.paymentMethod };
        if (this.paymentMethod === 'credit_card' || this.paymentMethod === 'wechat') {
          await this.payStripe();
        } else if (this.paymentMethod === 'apple_pay') {
          if(this.showSetupApple){
            this.setupApple();
          }else{
            await this.payApple();
          }
        } else {
          await this.payMongo();
        }
      }
    },
    back() {
      this.activeContent = 'select-duration';
    },
    backPayment() {
      this.activeContent = 'select-amount';
    },
    async payStripe() {
      let dataSend = {
        currency: this.subscribeData.currency,
        amount: this.subscribeData.price,
        identifier: this.subscribeData.identifier,
        recurring: this.subscribeData.recurring,
        success_url: this.getFromApps ? `${BASE_URL}/#/transaction-success` : `${BASE_URL}/#/subscription-success`,
        cancel_url: `${BASE_URL}/#/transaction-failed`,
      };
      if (!this.recurring) {
        dataSend = { ...dataSend, interval: this.oneTimeMonth };
      }
      const session = this.paymentMethod === 'wechat' ? await this.requestMakePaymentSubscriptionWeChat(dataSend) : await this.requestMakePaymentSubscription(dataSend);
      this.subscribeData = { ...this.subscribeData, session_id: session.id };
      this.setPaymentDataSubscription(this.subscribeData);
      this.setLoading();
      await this.$stripe.redirectToCheckout({ sessionId: session.id });
      this.unsetLoading();
    },
    async payMongo() {
      const price = (this.rangeVal * this.subscribeData.rate).toFixed(2);
      const dataSend = {
        type: this.paymentMethod,
        currency: 'PHP',
        amount: price,
        interval: this.oneTimeMonth,
        identifier: this.subscribeData.identifier,
        success_url: this.getFromApps ? `${BASE_URL}/#/transaction-success` : `${BASE_URL}/#/subscription-success`,
        failed_url: `${BASE_URL}/#/transaction-failed`,
      };
      const session = await this.requestMakePaymentSubscriptionPayMongo(dataSend);
      this.subscribeData = { ...this.subscribeData, session_id: session.data.data.data.id, checkout_url: session.data.checkout_url };
      this.setPaymentDataSubscription(this.subscribeData);
      this.setLoading();
      document.location.href = session.data.checkout_url;
    },
    async payApple() {
      const price = (this.subscribeData.price * this.subscribeData.rate).toFixed(2);
      const paymentRequest = {
        countryCode: 'US',
        currencyCode: 'USD',
        merchantCapabilities: ['supports3DS'],
        supportedNetworks: ['amex', 'masterCard', 'visa','discover'],
        total: { label: 'MusicVersePremium', amount: this.subscribeData.price.toString(), type: 'final' },
      };
      // eslint-disable-next-line no-undef
      const session = new ApplePaySession(3, paymentRequest);
      session.onvalidatemerchant = (event) => {
        console.log('validate yeuh', event);
        // Create the payload.
        const data = {
          validationUrl: event.validationURL,
        };
        this.merchantValidation(data)
          .then((response) => {
            // console.log(response.data, 'validate euy');
            const validationData = JSON.parse(response.data.data)
            console.log(validationData, 'validate euy');
            session.completeMerchantValidation(validationData);
          })
          .catch((err) => {
            console.log(err, 'error euy');
          });
      };
      session.onpaymentauthorized = (event) => {
        // Get the contact details for use, for example to
        // use to create an account for the user.
        console.log('dapet event', event);

        // Get the payment data for use to capture funds from
        // the encrypted Apple Pay token in your server.
        const token = event.payment.token.paymentData;
        this.authorizedPayment({ ...token });
        const authorizationResult = {
          // eslint-disable-next-line no-undef
          status: ApplePaySession.STATUS_SUCCESS,
          errors: [],
        };

        // Do something with the payment to capture funds and
        // then dismiss the Apple Pay sheet for the session with
        // the relevant status code for the payment's authorization.
        session.completePayment(authorizationResult);

        console.log('dapet token', token);
      };
      session.oncancel = (event) => {
        // Payment cancelled by WebKit
        console.log('cancel coy',event);
      };
      session.begin();
    },
    async createTransaction(data) {
      const url = `${API_URL}/webclient/apple-pay/validate`;
      return axios({
        url,
        method: 'post',
        data,
        headers: authHeader(),
      });
    },
    async merchantValidation(data) {
      const url = `${API_URL}/webclient/apple-pay/validate`;
      return axios({
        url,
        method: 'post',
        data,
        headers: authHeader(),
      });
    },
    async authorizedPayment(data) {
      const url = `${API_URL}/webclient/apple-pay/authPayment`;
      return axios({
        url,
        method: 'post',
        data,
        headers: authHeader(),
      });
    },
    async verifyPaymentPending() {
      Vue.swal({
        title: 'Warning',
        text: 'Payment in Confirmation',
        icon: 'warning',
        confirmButtonText: 'Verify Payment',
        cancelButtonText: 'Back to Home',
        showConfirmButton: true,
        showCancelButton: true,
        customClass: {
          cancelButton: 'btn btn-default',
        },
      }).then(async (result) => {
        if (result.value) {
          this.setLoading();
          const resp = await this.requestConfirmPaymentSubscriptionPayMongo({
            source_id: this.subscriptionTrxData.session_id,
          });
          this.unsetLoading();
          if (this.getStatus == 200) {
            if (resp.success) {
              this.$router.push({ name: 'HomePage' });
            } else {
              await this.verifyPaymentPending();
            }
          } else {
            await this.verifyPaymentPending();
          }
        } else {
          this.$router.push({ name: 'HomePage' });
        }
      });
    },
    supportedByDevice() {
      return 'ApplePaySession' in window;
    },
    supportsSetup() {
      // eslint-disable-next-line no-undef
      return 'openPaymentSetup' in ApplePaySession;
    },
    initApple() {
      if (this.supportedByDevice()) {
        const can = window.ApplePaySession.canMakePayments();
        if (can) {
          this.canApplePay = true;
        } else {
          // eslint-disable-next-line max-len
          window.ApplePaySession.canMakePaymentsWithActiveCard(APPLE_MERCHANT_ID).then((canMakePayments) => {
            if (canMakePayments === true) {
              this.canApplePay = true;
            } else if (this.supportsSetup()) {
              this.canApplePay = true;
              this.showSetupApple = true;
            } else {
              console.error('Apple Pay cannot be used at this time. If using macOS you need to be paired with a device that supports at least TouchID.');
            }
          });
        }
      }
    },
    async setupApple(){
      // eslint-disable-next-line no-undef
      ApplePaySession.openPaymentSetup(APPLE_MERCHANT_ID)
        .then((success) => {
          if (success) {
            this.payApple();
          } else {
            console.log("Failed to set up Apple Pay.");
          }
        }).catch( (e) => {
        console.log("Failed to set up Apple Pay. " + e);
      });
    }
  },
  components: {
    VueSlider,
  },
};
</script>

<style scoped>
  .btn-back{
    background: #C4C4C4;
    display: flex;
    width: 42px;
    height: 42px;
    cursor: pointer;
  }
  .icon-back{
    display: inline-block;
    margin: auto;
    color: #000000;
    font-size: 1.5rem;
  }
  .label-credits{
    margin-right:174px;
  }
  .checked-credit{
    margin-bottom: 40px;
  }
  .fire{
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #EA614F;
  }
  .range-container{
    padding: 32px;
    background: rgba(204, 204, 255,0.24);
    border-radius: 24px;
    margin-bottom: 40px;
  }
  .price-approx{
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    text-align: center;
    color: #224181;
  }
  .price-text{
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 43px;
    text-align: center;
  }
  .price-per-month{
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
  }

  .info-text{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: #767676;
  }

  .rule-1-price{
    color:#F57474;
  }
  .rule-2-price{
    color:#224181;
  }
  .rule-3-price{
    color:#224181;
  }
  .rule-4-price{
    color:#0A84FF;
  }
  .rule-5-price{
    color:#5856D6;
  }
  .rule-6-price{
    color:#FF9F0A;
  }
  .rule-4-info{
    font-weight: 700;
    color:#0A84FF;
  }
  .rule-5-info{
    font-weight: 700;
    color:#5856D6;
  }
  .rule-6-info{
    font-weight: 700;
    color:#FF9F0A;
  }
  .w-90{
    width: 90%;
    height: 34px;
  }
  @media all and (min-width: 768px) {
    .duration-container{
      max-width: 350px;
      margin: 0 auto;
    }

    .payment-container{
      max-width: 370px;
      margin: 0 auto;
    }
  }
  .duration-item{
    margin-bottom:24px;
  }
  .line-separator{
    height: 1px;
    width: 100%;
    background: #D9D9D9;
    margin-top:18px;
    margin-bottom: 24px;
  }
  .small-muted-text{
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #767676;
    margin-bottom: 18px;
  }
  .input-radio{
    margin-right: 26px;
    padding-top:4px;
  }
  .duration-text{
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    color: #4D4D4D;
    text-align: left;
    margin-bottom: 10px;
  }
  .duration-images img{
    width: auto;
    height: 16px;
    margin-right: 9px;
  }
  .payment-item{
    margin-bottom: 40px;
  }
  .input-radio-payment{
    margin-right: 26px;
  }
  .payment-method-label{
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    color: #4D4D4D;
  }
  .payment-method-images img{
    width: auto;
    height: 16px;
    margin-left: 6px;
  }
  .input-custom{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    text-decoration-line: underline;
    color: #19407F;
  }
  .input-custom-form{
    height: 56px;
    width: 100%;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 43px;
    text-align: right;
    color: #224181;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

</style>



// WEBPACK FOOTER //
// src/views/Subscribe.vue